<template>
    <footer
            class="footer"
            :class="{ [`footer-${type}`]: type }"
            :data-background-color="backgroundColor"
    >
        <div class="container">
            <nav>
                <ul>
                    <li><a href="#"> Home </a></li>
<!--                    <li><a href="#"> Contact Us </a></li>-->
<!--                    <li><a href="#"> Blog </a></li>-->
                    <li>
                        <router-link to="/login">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                 width="24" height="24"
                                 viewBox="0 0 172 172"
                                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ecf0f1"><path d="M86,7.16667l-64.5,28.66667c0,0 0,28.66667 0,43c0,56.115 46.14617,82.31633 64.5,86c18.35383,-3.68367 64.5,-29.885 64.5,-86c0,-14.33333 0,-43 0,-43zM86,43c11.85367,0 21.5,9.64633 21.5,21.5c0,11.85367 -9.64633,21.5 -21.5,21.5c-11.85367,0 -21.5,-9.64633 -21.5,-21.5c0,-11.85367 9.64633,-21.5 21.5,-21.5zM86,150.0485c-11.12267,-3.43283 -31.25383,-15.48 -42.32633,-37.48167c11.17283,-8.428 31.40433,-12.2335 42.32633,-12.2335c10.922,0 31.14633,3.8055 42.3335,12.2335c-11.07967,22.00167 -31.21083,34.04883 -42.3335,37.48167z"></path></g></g></svg>
                        </router-link>
                    </li>
                </ul>
            </nav>
            <div class="copyright">
                &copy; {{ year }},
                <a href="http:///signitive.ca" target="_blank" rel="noopener">Signitive Inc.</a>
                Design by <a href="http://bbst.org" target="_blank" rel="noopener">bbST.org</a
            >
            </div>
        </div>
    </footer>
</template>
<script>
    export default {
        props: {
            backgroundColor: String,
            type: String
        },
        data() {
            return {
                year: new Date().getFullYear()
            };
        }
    };
</script>
<style></style>
